import React from "react";
import axios from "axios";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import fasHeart from "@fortawesome/fontawesome-free-solid/faHeart";
import farHeart from "@fortawesome/fontawesome-free-regular/faHeart";
import "regenerator-runtime/runtime";

const dev = process.env.NODE_DEV === "dev";

export default class Like extends React.Component {
  constructor(props) {
    super(props);
    // set initial state to loading
    this.state = {
      loading: true,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const {title} = this.props;
    console.log("title", title);

    // check if there's a title
    if (!title) {
      return;
    }

    const functionPath = dev ?
      "https://oncezone.netlify.com/.netlify/functions/like/" :
      "/.netlify/functions/like/";
    
    // build url
    const encodedTitle = btoa(title);
    const url = `${functionPath}${encodedTitle}`;
    // fetch data
    this.getLikes(url);
  }

  async getLikes(url) {
    this.setState({url}); // save url

    let res;
    try {
      res = await axios.get(url);
      console.log(res.data);
    } catch (err) {
      console.error("Failed fetching function data:", err);
    }

    // save data to state
    const {success, likes, alreadyLiked} = res.data;
    this.setState({success, likes, alreadyLiked, loading: false});
  }

  async handleClick() {
    const {url} = this.state;
    let res;
    try {
      res = await axios.get(`${url}/submit`);
    } catch(err) {
      console.error("Failed submitting like:", err);
    }

    // save new data to state
    const {success, likes, alreadyLiked} = res.data;
    this.setState({success, likes, alreadyLiked});
  }

  render() {
    const {loading, success, alreadyLiked, likes} = this.state;

    if (loading) {
      return (
        <div>
          Loading likes...
        </div>
      );
    }

    if (!success) {
      return (
        <div>
          Something went wrong :(
        </div>
      );
    }

    // check if already liked
    let likeButton;
    if (!alreadyLiked) {
      likeButton = (
        <button
          type="button"
          onClick={this.handleClick}
          style={{
            background: "none",
            border: "none",
            fontSize: "1em",
            color: "blue",
          }}
        >
          <FontAwesomeIcon icon={farHeart} size="2x" color="#ED1566" />
        </button>
      );
    } else {
      likeButton = <FontAwesomeIcon icon={fasHeart} size="2x" color="#ED1566" />;
    }
    return (
      <div style={{display: "flex", alignItems: "center"}}>
        <span className="icon is-medium">
          {likeButton}
        </span>
        <span style={{marginLeft: "4px"}}>
          {likes}
          {likes === 1 ? "Like" : "Likes"}
        </span>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Like/index.jsx